export default __webpack_public_path__ + "static/media/delivery-truck.95f52472.svg";